<template>
    <div class="knd-chat__item__inner"
        :class="{show: show}"
        v-if="message.profile.length > 0 && message.type.length > 0" 
    >
    <div class="chat-content__message chat-message-right knd-flex knd-my-2" 
        :class="['knd-'+ message.profile[0].titel, message.type[0].titel === 'MULTIPLE' ? 'knd-multiple' : '']"
      >
            <div v-if="message.type[0].titel === 'MESSAGE'" 
                class="knd-px-2 knd-py-2 knd-mb-5 knd-rounded-md knd-inline-block chat-content__message_inner"
                :class="{'bg-operator': message.profile[0].titel === 'operator', 'knd-bg-jade': message.profile[0].titel === 'user'}"
            >   
                <div v-if="showIsTyping">
                    <IsTyping />    
                </div>
                <div v-else v-html="output_text(message.content)">
                </div>
            </div>

            <div v-if="message.type[0].titel === 'MULTIPLE'">
                <div class="knd-text-center">
                    <div class="knd-inline-block knd-bg-red knd-text-white knd-px-5 knd-py-2 knd-my-2 knd-rounded-md knd-text-center">
                        kies een optie
                    </div>
                </div>

                <div class="knd-flex knd-justify-end knd-items-center"
                    v-for="(option, index) in message.options" 
                    :key="option.content"
                    @click="handleMultipleChoice('sm' + index)"
                >   
                    <div class="multiple-feedback">
                        <div class='' v-if="picked && picked ==='sm' +index">
                            <img v-if="option.correct" class="knd-match__icon" src="@/assets/icons/heart.svg" />
                            <img v-else class="knd-match__icon" src="@/assets/icons/reject.svg" />
                        </div>
                    </div>
                    <div class="knd-rounded-md knd-my-2 knd-px-2 knd-py-2 knd-border-red-light knd-border-2 knd-text-white knd-multiple-option"
                        :class="{'knd-bg-red-light knd-text-black': 'sm' +index === picked}"
                        v-html="output_text(option.content)">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import IsTyping from './IsTyping.vue';
import {output_text} from '../../utils/main';

export default defineComponent({
  name: "Message",
  props: {
    delay: {
        type:Number,
        default: 0
    },
    wait: {
        type:Number,
        default: 0
    },
    simulate: {
        type:Boolean,
        default: false
    },
    show: {
        type:Boolean,
        default: false     
    },
    message: {}    
  },
  data: function() {
    return {
        once: false,
        showIsTyping: true,
        savedName: false,
        reaction: false,
        picked: undefined,
        output_text: output_text
    }
  },
  created () {},
  components: {
    IsTyping
  },
  watch: { 
    show: function(newVal, oldVal) { // watch it
        // console.log('Prop changed: ', newVal, ' | was: ', oldVal);
        this.handleMessage();
    }
  },
  methods: {
    async waitForIt(){
        await this.sleep(this.wait);
        this.reaction = true;
    },

    async onChange(waypointState) {
        this.once = true;

        if(this.simulate) {
            await this.waitForIt();
        } else {
            this.reaction = true;
        }

        switch(this.message.type[0].titel) {
            case 'MESSAGE':
                this.handleMessage();
                break;
        }
    },

    sleep(delay) {
        return new Promise((resolve) => setTimeout(resolve, delay))
    },

    async handleMessage(){
        if(this.simulate) {
            await this.sleep(this.delay);
        }

        this.showIsTyping = false;

        this.emit();
    },

    emit() {
        this.$emit('created');
    },

    handleMultipleChoice(index) {
        this.picked = index;
    },

    onEnter(){
        this.savedName = true;
        this.$refs.input.disabled =true;
        this.emit();
    }
  }
});
</script>

<style lang="scss" scoped>
    .knd-chat__item__inner {
        opacity: 0;

        transition: opacity .5s ease-in;

        &.show {
            opacity: 1;
        }
    }
    .chat-content__message_inner {
        max-width: 75%;
        @screen md {
            max-width: 50%;
        }

    }

    .knd-input {
        background: transparent;
        margin-left: 1em;
        border-bottom: 1px dashed #000;        
    }

    .chat__radio {
        margin:0;padding:0;
        position: absolute;
        -webkit-appearance:none;
        -moz-appearance:none;
        appearance:none;
    }

    .knd-chat-user {
        .bg-operator {
            background: theme('colors.green.light');
        }        
    }
    .knd-chat-operator .bg-operator {
        background: theme('colors.red.light');
    }

    .multiple-feedback {
        flex: 0 0 50px;

        img {
            max-width: 50px;
        }
    }
</style>